import ErrorView from 'components/QueryBoundaries/ErrorView'
import Home from 'pages/Home'
import { createBrowserRouter } from 'react-router-dom'

const routes = createBrowserRouter([
  {
    path: '*',
    element: <Home />,
    errorElement: <ErrorView title="Erro!" description="Ocorreu um erro ao carregar a página." />,
  },
])

export default routes
